// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
import { getEnabledPackage } from './initializer';
export class PackageInitializerServer {
    /* eslint-enable @typescript-eslint/naming-convention */
    constructor(packageContext) {
        this._sideEffects = packageContext.sideEffects;
        this._settings = packageContext.settings;
        this._dependencies = packageContext.dependencies ?? [];
    }
    checkDependencies() {
        this._dependencies.forEach((dependency) => {
            // The package name is the name found in each package's package.json file e.g. @sitecore-cloudsdk/core"
            const depName = dependency.name.split('/')[1];
            if (!getEnabledPackage(dependency.name))
                throw new Error(// eslint-disable-next-line max-len
                `[IE-0021] - This functionality also requires the "${depName}" package. Import "${dependency.name}/server", then run ".${dependency.method}()" on "CloudSDK", before ".initialize()"`);
        });
    }
    async exec() {
        this.checkDependencies();
        await this._sideEffects();
    }
    get settings() {
        return this._settings;
    }
}
